class HasTableStrategy {
  constructor(vue) {
    this.$vm = vue
  }

  async finally(initalData) {
    // 更新数量
    this.$vm.updateAmount()
    //
    this.$vm.handlerFinally(initalData)
  }
}

export default HasTableStrategy
